<div class="dialog-container step-pagination">
  <button class="close-btn" mat-icon-button (click)="close()">✕</button>

  <ng-container [ngSwitch]="step">
    <app-first-step-add-establishment
      *ngSwitchCase="1"
      [form]="firstStepFormGroup"
      [loading]="loading"
      (onValidated)="next()"
    ></app-first-step-add-establishment>

    <app-second-step-add-establishment
      *ngSwitchCase="2"
      [form]="secondStepFormGroup"
    ></app-second-step-add-establishment>

    <app-third-step-add-establishment
      *ngSwitchCase="3"
      [form]="thirdStepFormGroup"
    ></app-third-step-add-establishment>

    <app-final-step-add-establishment
      *ngSwitchCase="4"
      [form]="finalStepFormGroup"
      [loading]="loading"
    ></app-final-step-add-establishment>
  </ng-container>

  <div *ngIf="step > 1" class="actions d-flex justify-content-between mt-4">
    <button mat-stroked-button (click)="back()" [disabled]="loading">
      Retour
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="next()"
      [disabled]="loading || isCurrentStepInvalid"
    >
      {{ step < 3 ? 'Suivant' : 'Terminer' }}
    </button>
  </div>
</div>